"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FFResultEvent = exports.FFResultStatus = void 0;
var FFResultStatus;
(function (FFResultStatus) {
    FFResultStatus["OK"] = "OK";
    FFResultStatus["NOK"] = "NOK";
})(FFResultStatus || (exports.FFResultStatus = FFResultStatus = {}));
var FFResultEvent = /** @class */ (function () {
    function FFResultEvent() {
    }
    FFResultEvent.success = function (result) {
        return { result: result, status: FFResultStatus.OK };
    };
    FFResultEvent.failure = function (error) {
        return { error: error, status: FFResultStatus.NOK };
    };
    return FFResultEvent;
}());
exports.FFResultEvent = FFResultEvent;
